<template>
  <PageView class="full-page" :no-sub-title-expected="true">
    <TitleView>{{ $t("forgotPassword.title") }}</TitleView>

    <ContentView>
      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <b-message v-if="passwordSent" type="is-success">
          {{ $t("forgotPassword.passwordsent") }}
        </b-message>

        <b-message v-if="passwordSent" type="is-warning">
          {{ $t("forgotPassword.checkspams") }}
        </b-message>

        <b-message v-if="!passwordSent" type="is-info">
          {{ $t("forgotPassword.explain") }}
        </b-message>
        <InputWithValidation
          v-if="!passwordSent"
          v-model="email"
          rules="required|email"
          type="email"
          :custom-error="passworderror"
          :placeholder="$t('input-login-tooltip')"
          :label="$t('input-login')"
        />
        <div class="left-button">
          <b-button v-if="!passwordSent" type="is-primary" @click="handleSubmit(submit)">
            {{ $t("forgotPassword.send") }}
          </b-button>
        </div>
      </ValidationObserver>
    </ContentView>
  </PageView>
</template>

<script lang="ts">
import { BMessage, BButton } from "buefy"

import { defineComponent } from "vue"
import TitleView from "@/views/commons/TitleView.vue"
import ContentView from "@/views/commons/ContentView.vue"
import PageView from "@/views/commons/PageView.vue"
import ValidationObserver from "@/services/validation/ValidationObserver.vue"
import InputWithValidation from "@/views/inputs/InputWithValidation.vue"
import { LoginService } from "@/services/rest/login/LoginService"

export default defineComponent({
  name: "ForgotPasswordPage",
  components: {
    TitleView,
    ContentView,
    PageView,
    InputWithValidation,
    ValidationObserver,
    BButton,
    BMessage,
  },
  props: {
    defaultEmail: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      passwordSent: false,
      email: "",
      passworderror: "",
      loginService: LoginService.INSTANCE,
    }
  },
  mounted(): void {
    this.email = this.defaultEmail.trim()
  },
  methods: {
    submit(): void {
      this.loginService.forgotPassword(this.email).then(
        (_success) => {
          this.passwordSent = true
        },
        (_reject) => {
          this.passworderror = this.$t("forgotPassword.error").toString()
        },
      )
    },
  },
})
</script>
<style lang="scss">
.left-button {
  display: flex;
  justify-content: flex-end;
}
</style>
